'use client';

import { useEffect, useState } from 'react';
import { useAppStore } from '@/store/app';
import { NEWBIE_KEY } from './FirstVisitGuide';

type Lang = 'en' | 'zh-Hant' | 'zh-Hans';

const COPY: Record<Lang, string> = {
  en: 'Newbie mode is on - simpler explanations are shown across the app.',
  'zh-Hans': '新手模式已开启：全站将显示更简单的解释与引导。',
  'zh-Hant': '新手模式已開啟：全站將顯示更簡單的解釋與引導。',
};

/** Dismissible top banner shown once per session while newbie mode is on. */
export default function NewbieHint() {
  const language = useAppStore((s) => s.language) as Lang;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const on = localStorage.getItem(NEWBIE_KEY) === '1';
      const seen = sessionStorage.getItem('ailumix:hint:seen');
      if (on && !seen) {
        sessionStorage.setItem('ailumix:hint:seen', '1');
        setShow(true);
      }
    } catch { /* ignore */ }
  }, []);

  if (!show) return null;
  const text = COPY[language] ?? COPY['zh-Hans'];

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9990, background: '#0d9488', color: '#fff', fontSize: 13, padding: '8px 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
      <span>{text}</span>
      <button onClick={() => setShow(false)} style={{ background: 'none', border: 'none', color: '#d6fff4', fontSize: 15, cursor: 'pointer', lineHeight: 1, padding: '2px 6px' }} aria-label="close">×</button>
    </div>
  );
}
